import { EPDCopyGroupStatus, EPDStatusDisplayName } from 'services/EpdClient';

export enum DashboardItemType {
  Epd = 'Epd',
  DynamicFormDocument = 'DynamicFormDocument',
  CopyGroup = 'CopyGroup',
}

export enum DashboardViewMode {
  Epds = 'Epds',
  CopyGroups = 'CopyGroups',
}

export enum DashboardSortField {
  RegistrationNumber = 'RegistrationNumber',
  Name = 'Name',
  Status = 'Status',
  VersionDate = 'VersionDate',
  ValidityDate = 'ValidityDate',
}

/**
 * Slim dashboard list item shared by EPDs, Dynamic Forms documents, and EPD Copy Groups.
 * Full record details are loaded on demand once a specific item is opened.
 */
export interface DashboardListItemModel {
  id: string;
  type: DashboardItemType;
  registrationNumber?: string;
  name?: string;
  /** Populated for Epd and DynamicFormDocument items. */
  statusDisplayName?: EPDStatusDisplayName;
  /** Populated for CopyGroup items. */
  groupStatus?: EPDCopyGroupStatus;
  versionDate?: string;
  validityDate?: string;
  createdAt: string;
  /** Populated for DynamicFormDocument items only. */
  latestOperationAt?: string;
  /** Populated for Epd items only. */
  isCompilerFormat?: boolean;
  /** Populated for Epd items only. */
  coverFileId?: string;
  /** Populated for Epd items only. */
  friendlyUrl?: string;
  /** Populated for Epd and DynamicFormDocument items. */
  publishedVersionId?: string;
  /**
   * Version date of the last published version. Populated for Epd items (live published version only)
   * and DynamicFormDocument items (also after depublication and deregistration).
   */
  publishedVersionDate?: string;
  /** Populated for CopyGroup items only. */
  itemsCount?: number;
}

export interface DashboardSearchRequest {
  accountId?: string;
  companyId?: string;
  viewMode: DashboardViewMode;
  searchTerm?: string;
  statuses: string[];
  formats: string[];
  excludeCollectionId?: string;
  sortField?: DashboardSortField;
  sortOrder: 1 | -1;
  pageNumber: number;
  pageSize: number;
}

export interface DashboardQuickStatsRequest {
  accountId?: string;
  companyId?: string;
  viewMode: DashboardViewMode;
}

export interface DashboardQuickStatsModel {
  statusCounts: Record<string, number>;
  hasStandardFormat: boolean;
  hasCompilerFormat: boolean;
}
